import styles from './WelcomeCard.module.css';
import { WelcomeCardProps } from './models/welcome-card-props';

export const WelcomeCard: React.FC<WelcomeCardProps> = ({ eyebrow, title, description, image, children }) => (
    <s-section padding="none">
        <div className="relative flex h-full items-center gap-4 overflow-hidden p-4 card-fix-height">
            <div className={`relative z-10 flex min-w-0 flex-1 flex-col gap-3 px-6 ${image ? styles.content : ''}`}>
                <div className="flex flex-col gap-1">
                    {eyebrow && <div className="text-body-lg font-semibold">{eyebrow}</div>}
                    <div className="text-heading-xl font-bold">{title}</div>
                    {description && <div className="text-body-md text-text-subdued">{description}</div>}
                </div>
                {children && <div className="flex flex-col gap-2">{children}</div>}
            </div>
            {image && <img src={image.src} alt={image.alt} className={`hidden md:block ${styles.image}`} />}
        </div>
    </s-section>
);
